import React from 'react'

export default function Nav(props) {
  return (
    <nav className="bg-gradient-to-r from-zinc-900 via-zinc-700 to-zinc-900 w-screen h-24 flex justify-between items-center px-7">
        <div className="h-full">
            <img className="h-5/6" src="images/logo.png" alt="Prem Agarwal's"/>
        </div>

        <div id="nav-bg" className="bg-zinc-600 md:bg-transparent fixed md:relative top-0 left-0 h-0 w-screen md:h-24 md:w-auto flex justify-center items-center transition-all z-20">
            <ul id="nav-text" className="md:relative font-semibold top-0 left-0 h-full md:h-auto w-full overflow-hidden md:w-auto flex md:flex flex-col md:flex-row md:pr-6 justify-center items-center md:justify-between text-xl lg:text-2xl  uppercase bg-gradient-to-r from-cyan-100 to-cyan-600 bg-clip-text text-transparent">
                <li className="nv my-1 lg:mx-5 md:mx-5 md:my-0 cursor-pointer border-zinc-900 transition-all pb-3 md:pb-0" onClick={() => {props.fun('project')}}>Project</li>
                <li className="nv my-1 lg:mx-5 md:mx-5 md:my-0 cursor-pointer border-zinc-900 transition-all pb-3 md:pb-0" onClick={() => {props.fun('about')}}> About </li>
                <li className="nv my-1 lg:mx-5 md:mx-5 md:my-0 cursor-pointer border-zinc-900 transition-all pb-3 md:pb-0" onClick={() => {props.fun('experience')}}>Experience</li>
                <li className="nv my-1 lg:mx-5 md:mx-5 md:my-0 cursor-pointer border-zinc-900 transition-all pb-3 md:pb-0" onClick={() => {props.fun('contact')}}>Contact</li>
            </ul>
        </div>
        <span id="nav-but" className="transition-all flex align-middle h-10 text-3xl md:hidden mt-[1rem] text-cyan-100 z-30"> <i className="fa-solid fa-bars"></i> </span>
    </nav>
  )
}


